import React, { Component } from 'react';
import {observer} from "mobx-react"
import SortieStore from "../SortieStore"
import axios from "axios"
import { HashRouter as Router, Route, Link } from "react-router-dom";
import TakePicture from "./TakePicture"


@observer
export default class Pictures extends React.Component {
  constructor(props) {
    super(props);
    this.loadImages = this.loadImages.bind(this)
    this.state = {
      images: []
    };
    this.loadImages()
  }

  loadImages(){
    axios.post("/api/v1/experts/app/sortie/imagesCompteurs",{id: SortieStore.rdv.id}).then((data)=>{
      this.setState({
        images: data.data
      })
    })
  }
  render() {
    if(SortieStore.loaded){

      return(
        <div>
          <h1 className="center">Images des compteurs</h1>
          <div className="row">
            <div className="col s2">
              <div className="row">
              {this.state.images.map((image)=>(
                <div key={image.id} className="col s12">
                  <img className="responsive-img" src={image.url} alt=""/>
                </div>
              ))}
              </div>
            </div>
            <div className="col s9 offset-s1">
              <TakePicture
              sortie={SortieStore.rdv.id}
              reloadImages={this.loadImages}
              />
            </div>
          </div>
        </div>
        )
    }else{
     return (
        <div>
        Chargement en cours
        </div>
      );
   }
  }
}


